import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function Solutions() {
  return (
    <>
      {/* ---------- over solution section start ---------- */}
      <section className="solution_bg">
        <div className="container">
          <div className="row align-items-center p-md-0 p-4 g-4">
            <div className="col-md-6 order-md-1 order-2">
              <div className="text-light">
                <motion.h3
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h3 fw-bold mb-3"
                >
                  Solutions That Solve Real Challenges
                </motion.h3>
                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="mb-lg-5 mb-0"
                >
                  Be it a DeFi, crypto exchange, or metaverse infrastructure,
                  our professional team offers comprehensive blockchain
                  solutions that solve, scale, and stand out.
                </motion.p>
                <Link
                  to="https://teams.live.com/l/invite/FEAgoDJPJi4z_OT7QI"
                  target="_blank"
                >
                  <motion.button
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    class="button theme_btn text-light mt-4 mt-lg-0"
                    type="submit"
                  >
                    Talk To Our Team!
                  </motion.button>
                </Link>
              </div>
            </div>
            <div className="col-md-6 order-md-2 order-1">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="d-flex justify-content-center"
              >
                <img
                  src="assets/images/about/solu2.webp"
                  alt=""
                  className="w-100"
                />
              </motion.div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
